import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 导入Excel ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 查看 ");

const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " 请下载Excel模板，严格按照字段的属性填写相关信息，保存后上传到系统，任何字段信息有误均会导致导入失败。一次导入上限为5000条。 ", -1);

const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "1. 发货方、客户ID和客户名称为必填项", -1);

const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "2. 发货方名称必须严格按照万药城中发货方名称填写, 不可随意填写", -1);

const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "3. 发货方必须填写万药城中已认证的发货方名称", -1);

const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "4. 客户ID和客户名称均在万药城中可查和导出, 不可随意填写", -1);

import { reactive, ref, computed, watch } from 'vue';
import { getVexTableProps } from '@/config';
import { getBranchCustInfoList } from '@/request';
import { useStore } from 'vuex';
import { importBranchCustRelationExcel, importBranchCustRelation } from '@/request/api';
import UploadModal from '@/components/UploadModal.vue';
import EditDistributorCustomerModal from './component/EditDistributorCustomerModal.vue';
import BindCustomerModal from './component/BindCustomerModal.vue';
export default {
  name: 'DistributorCustomerManage',

  setup(__props) {
    const store = useStore();
    store.dispatch('getDictList');
    const dictList = computed(() => store.state.dictList);
    const form = reactive({
      branchName: '',
      branchArea: [],
      linkMan: '',
      bindingCustFlag: ''
    });
    const uploadOption = {
      action: importBranchCustRelation.url,
      name: 'file',
      templateLink: importBranchCustRelationExcel.url,
      title: '导入',
      errorExcelName: '发货方与客户关系-失败数据'
    };
    const formRef = ref();
    const table = ref();
    const showUploadModel = ref(false);
    const showEditDistributorCustomerModal = ref(false);
    const showBindCustomerModal = ref(false);
    const currentRow = ref(null);

    function reset() {
      formRef.value.resetFields();
      table.value.commitProxy('reload');
    }

    function edit(row) {
      currentRow.value = row;
      showEditDistributorCustomerModal.value = true;
    }

    function see(row) {
      currentRow.value = row;
      showBindCustomerModal.value = true;
    }

    watch(() => showEditDistributorCustomerModal.value, newVal => {
      if (!newVal) {
        table.value.commitProxy('reload');
      }
    });
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        field: 'branchName',
        title: '发货方名称',
        width: '200px',
        showOverflow: true
      }, {
        field: 'branchAddress',
        title: '详细地址',
        width: '300px',
        showOverflow: true
      }, {
        field: 'branchArea',
        title: '所在区域',
        width: '200px',
        showOverflow: true
      }, {
        field: 'linkMan',
        title: '联系人',
        width: '150px',
        showOverflow: true
      }, {
        field: 'linkPhone',
        title: '联系电话',
        width: '200px',
        showOverflow: true
      }, {
        field: 'custNumber',
        title: '绑定客户数',
        width: '200px',
        showOverflow: true
      }, {
        field: 'registerTime',
        title: '注册时间',
        width: '200px',
        showOverflow: true
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '200px',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getBranchCustInfoList(_objectSpread(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form), {}, {
              branchArea: form.branchArea.join(',')
            })).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.branchCustInfoList
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_form = _resolveComponent("el-form");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        model: form,
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "branchName",
              label: "发货方名称"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.branchName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.branchName = $event),
                modelModifiers: {
                  trim: true
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "branchArea",
              label: "发货方区域"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.branchArea,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.branchArea = $event),
                multiple: "",
                "collapse-tags": ""
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dictList), dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: dict.text,
                    value: dict.id,
                    key: dict.id
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              prop: "linkMan",
              label: "发货方联系人"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.linkMan,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.linkMan = $event),
                modelModifiers: {
                  trim: true
                }
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "是否绑定客户",
              prop: "bindingCustFlag"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.bindingCustFlag,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.bindingCustFlag = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "是",
                  value: "1"
                }), _createVNode(_component_el_option, {
                  label: "否",
                  value: "0"
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, {
          justify: "end"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: "Search",
            onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
          }, {
            default: _withCtx(() => [_hoisted_1]),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            icon: "Refresh",
            onClick: reset
          }, {
            default: _withCtx(() => [_hoisted_2]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "Upload",
          onClick: _cache[5] || (_cache[5] = $event => showUploadModel.value = true)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        })]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Edit",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["onClick"]), row.custNumber !== 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          icon: "view",
          onClick: $event => see(row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)]),
        _: 1
      }, 16), _createVNode(UploadModal, {
        option: uploadOption,
        modelValue: showUploadModel.value,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => showUploadModel.value = $event)
      }, {
        help: _withCtx(() => [_hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(EditDistributorCustomerModal, {
        data: currentRow.value,
        modelValue: showEditDistributorCustomerModal.value,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => showEditDistributorCustomerModal.value = $event)
      }, null, 8, ["data", "modelValue"]), _createVNode(BindCustomerModal, {
        data: currentRow.value,
        modelValue: showBindCustomerModal.value,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => showBindCustomerModal.value = $event),
        isSee: true
      }, null, 8, ["data", "modelValue"])]);
    };
  }

};